import { render, staticRenderFns } from "./importSettings.vue?vue&type=template&id=63189998&scoped=true"
import script from "./importSettings.vue?vue&type=script&lang=js"
export * from "./importSettings.vue?vue&type=script&lang=js"
import style0 from "./importSettings.vue?vue&type=style&index=0&id=63189998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63189998",
  null
  
)

export default component.exports